import { createSlice } from "@reduxjs/toolkit";
import Api from "services/api";

const initialState = {
  translators: [],
  error: null,
  loader: false,
};

const translatorSlice = createSlice({
  name: "translators",
  initialState,
  reducers: {
    setTranslator: (state, { payload }) => {
      state.translators = payload ?? [];
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    clearTranslator: (state) => {
      state.translators = [];
      state.error = null;
      state.loader = false;
    },
  },
});

export const { setTranslator, setError, setLoader, clearTranslator } =
  translatorSlice.actions;

export const fetchTranslators = () => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.fetchTranslator();
    if (result?.status >= 200 && result.status < 300) {
      dispatch(setTranslator(result.data?.data || []));
    } else {
      dispatch(setError(result.data || "Failed to fetch clients"));
    }
  } catch (error) {
    console.error("fetchTranslator error:", error);
    dispatch(setError(error?.message || "Something went wrong"));
  }
  dispatch(setLoader(false));
};

export default translatorSlice.reducer;
